$(function () {
  $(".topnavi .current").get(0)?.scrollIntoView();
  $(".drinkmenu .current").get(0)?.scrollIntoView();
  $(".brandmenu .current").get(0)?.scrollIntoView();
});
